import Box from '@mui/material/Box';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReduxState } from '../../../store';
import { ADMIN_SERVER_BASE_URL, apiClient } from '../../../util/apiClient';
import CommonListe from '../../Common/CommonListe';
import { deleteModule, IModule, setObjModule, setOpenDialogModule, setValueEdit } from './moduleSlice';




const ListeModule = () => {


    //redux
    const dispatch = useDispatch()
    const { modules, objModule } = useSelector((state: IReduxState) => state.module);

    const deleteItem = async (item: any) => {
        try {
            const apiPayload = { idModule: item.idModule }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/supprimermodule", apiPayload)
            if (res.status === 1) {
                dispatch(deleteModule(res.data))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };



    const handleEditDialogOpen = (item: IModule) => {
        dispatch(setOpenDialogModule(true))
        dispatch(setObjModule(item))
        dispatch(setValueEdit(item.libelleModule))
    }


    return (
        <Box sx={{ width: '100%',  bgcolor: 'background.paper' }}>
            <CommonListe
                data={modules}
                deleteItem={deleteItem}
                setItem={setObjModule}
                handleEditDialogOpen={handleEditDialogOpen}
            />
        </Box >
    );
}

export default ListeModule;
